<script setup lang="ts">
/* Login form */
import LoginForm from "@/components/auth/LoginForm.vue";
import { PublicView } from "@/utils/asyncLoading";
import loggerLocal from "@/utils/loggerLocal";
const { t } = useI18n();
loggerLocal.info("👋 SideLogin.vue mounted");
</script>

<template>
  <PublicView :title="t('auth.signIn')" :description="t('auth.signInDescription')">
    <template #element2Show><LoginForm /></template>
  </PublicView>
</template>
